<div class="input-container">
    <div [ngSwitch]="activeInputMenuItem">
        <div class="input-content" *ngSwitchCase="'Add Section'"></div>
        <!-- <div class="input-content" *ngSwitchCase="'Grid'">
            <kve-home-input-grid [activeInputMenuItem]="activeInputMenuItem"></kve-home-input-grid>
        </div>
        <div class="input-content" *ngSwitchCase="'Add New Grid'">
            <kve-add-grid></kve-add-grid>
        </div>
        <div class="input-content" *ngSwitchCase="'Edit Existing Grid'">
            <kve-edit-grid></kve-edit-grid>
        </div>
        <div class="input-content" *ngSwitchCase="'Banner'">
            <kve-home-input-banner></kve-home-input-banner>
        </div>
        <div class="input-content" *ngSwitchCase="'Slider'">
            <kve-home-input-slider></kve-home-input-slider>
        </div>
        <div class="input-content" *ngSwitchCase="'Blog List'">
            <div>Blog List</div>
        </div>
        <div class="input-content" *ngSwitchCase="'Slide Show'">
            <kve-home-input-slideshow></kve-home-input-slideshow>
        </div> -->
        <div class="input-content" *ngSwitchDefault>
            <nb-tabset (changeTab)="tabChanged($event)">
                <nb-tab tabTitle={{defaultInputMenuItem}}>
                    <kve-home-input-default></kve-home-input-default>
                </nb-tab>
                <nb-tab tabTitle="Sections">
                    <kve-sections-editor></kve-sections-editor>
                </nb-tab>
            </nb-tabset>
            <!-- <div class="active-menu-item">{{defaultInputMenuItem}}</div> -->

        </div>
    </div>
</div>